import { render, staticRenderFns } from "./inputSKU.vue?vue&type=template&id=ff59541e&scoped=true"
import script from "./inputSKU.vue?vue&type=script&lang=js"
export * from "./inputSKU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff59541e",
  null
  
)

export default component.exports